import axios from 'axios';

const API_URL = 'https://pdks.bytebridge.com.tr/api/official-holidays';

export async function fetchOfficialHolidays() {
  try {
    const res = await axios.get(API_URL);
    return res.data;
  } catch (err) {
    return [];
  }
}

// Tatil aralığında mı?
export function isHoliday(date, holidayList) {
  // holidayList'in array olup olmadığını kontrol et
  if (!Array.isArray(holidayList) || holidayList.length === 0) {
    return false;
  }
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const dateStr = `${year}-${month}-${day}`;
  return holidayList.some(h => {
    const start = h.startDate || h.date;
    const end = h.endDate || h.date;
    return dateStr >= start && dateStr <= end;
  });
}
